/* Underscores default stuff */

// import './../../js/navigation';
// import './../../js/skip-link-focus-fix';

import './../scss/app.scss';
import './vue/app';
import './profet';
import './exitIntentPoll';
// Meta Conversions API is disabled (NKW-30)
// import './capiTracking';

var cookie = getCookie('haelo_popup');
console.log('cookie', cookie);

var param = location.search.split('referrer=')[1];
if (param && param === 'haelo' && !cookie) {
  console.log('GOT HERE!');
  var elem = document.createElement('div');
  elem.className = 'haelo-popup-background';
  elem.id = 'haelo-popup-background-id';
  document.body.prepend(elem);
  var popup = document.createElement('div');
  popup.className = 'haelo-popup';
  popup.id = 'haelo-popup-id';
  document.body.prepend(popup);
  var titleWrapper = document.createElement('div');
  titleWrapper.className = 'haelo-title-wrapper';
  var title = document.createElement('p');
  title.innerHTML = 'Haelo är nu en del av Nordiska Kliniken.';
  title.className = 'popup-title';
  titleWrapper.append(title);
  var title = document.createElement('p');
  title.innerHTML = 'Varmt välkommen!';
  title.className = 'popup-subtitle';
  titleWrapper.append(title);
  popup.append(titleWrapper);
  var button = document.createElement('button');
  button.className = 'popup-button';
  button.innerHTML = 'Jag förstår';
  button.onclick = () => setCookie('haelo_popup', true, 10000);
  popup.append(button);
  var imageOne = document.createElement('img');
  imageOne.src =
    'https://www.nordiskakliniken.se/wp-content/uploads/2024/09/NK-logo-primary-centered-black.png';
  imageOne.className = 'popup-image popup-image-nk popup-image-first';
  var imageTwo = document.createElement('img');
  imageTwo.src =
    'https://www.nordiskakliniken.se/wp-content/uploads/2024/09/haelo_logo_dark-purple.png';
  imageTwo.className = 'popup-image popup-image-nk popup-image-second';
  var imageWrapper = document.createElement('div');
  imageWrapper.className = 'popup-image-wrapper';
  imageWrapper.append(imageTwo);
  var divider = document.createElement('span');
  divider.innerHTML = '=';
  divider.className = 'popup-image-divider';
  imageWrapper.append(divider);
  imageWrapper.append(imageOne);
  popup.prepend(imageWrapper);
}

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.getElementById('haelo-popup-background-id').style =
    'display: none !important;';
  document.getElementById('haelo-popup-id').style = 'display: none !important;';
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
